/**
 * @desc 出库情况导出
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.demandOrder.exWarehouseExport.Params, options?: any) {
  return updateResponse(
    http(URL + `/wms/demandOrder/exWarehouse/export`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
